import { Button, Tooltip } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import React from "react"
import { useIntl } from "react-intl"

type Props = {
  onRemove?: () => void
  target: string
}

export const RemoveButton = ({ onRemove, target }: Props) => {
  const intl = useIntl()

  return (
    <Tooltip
      placement="top"
      title={intl.formatMessage({ id: "common.remove" }, { target: () => target })}
    >
      <Button shape="circle" type="dashed" icon={<DeleteOutlined />} onClick={() => onRemove?.()} />
    </Tooltip>
  )
}
